<template>
  <div class="infinite-load">
    <infinite-loading
      @infinite="getData"
      :identifier="infiniteId"
      direction="bottom"
      class="infinite-text"
      ref="infinite"
      :force-use-infinite-wrapper="wrapperClass"
    >
      <div slot="spinner">{{ $t("public.loading") }}</div>
      <div slot="no-more">{{ $t("public.no_more") }}</div>
      <div slot="no-results">
        <el-empty :description="noResText || $t('public.no_data')"></el-empty>
      </div>
    </infinite-loading>
  </div>
</template>

<script>
import infiniteLoading from "vue-infinite-loading";
export default {
  components: { infiniteLoading },
  name: "loading",
  props: {
    handleInfinite: {
      type: Object,
    },
    noResText: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      infiniteId: +new Date(),
    };
  },
  methods: {
    getData($state) {
      const infinite = this.infiniteId;
      if (infinite === this.infiniteId) {
        this.$emit("getData", $state);
      }
    },
    reSet() {
      this.infiniteId += 1;
    },
  },
};
</script>

<style  scoped>
.infinite-load {
  width: 100%;
}
.infinite-text {
  color: #b3d3ff;
  padding: 10px 0;
  font-size: 16px;
}
</style>